import { TPKColors } from '../../../colors'
import { QuestionMark, WinningBadge } from '../WinningBadge'
import React from 'react'
import styled from 'styled-components'
import { type WinningProps } from './WinningCard'

export const WinningIcon = ({ winning, type, selected }: WinningProps) => (
    <StyledWinningIconContainer
        selected={selected}
        accentColor={
            type === 'CHILD' ? TPKColors.childAccent : TPKColors.parentAccent
        }>
        {winning ? (
            <StyledWinningImageContainer>
                <StyledWinningImage src={winning.imageUrl} alt={winning.name} />
            </StyledWinningImageContainer>
        ) : (
            <QuestionMark
                borderColor={
                    type === 'CHILD'
                        ? TPKColors.childAccent
                        : TPKColors.parentAccent
                }
            />
        )}
        <WinningBadge selected={selected} type={type} />
    </StyledWinningIconContainer>
)

const StyledWinningIconContainer = styled.div`
    position: relative;
    transform: translateX(-2px);

    transition: transform 50ms ease;
    margin-bottom: 8px;
    z-index: 2;
`

const StyledWinningImageContainer = styled.div`
    position: absolute;
    z-index: 4;
    left: 10%;
    top: 10%;
    right: 10%;
    bottom: 10%;
`

const StyledWinningImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
    margin: 0 auto;
`
